module.exports = __webpack_public_path__ + "img/black_chevron_right.24486938.png";